import L from 'leaflet';

export default class ShopsMap extends HTMLDivElement
{
    connectedCallback()
    {
        this.bounds = [];
        this.iconUrl = "";
        this.mapMarkers = [];
        this.clusters = [];
        this.lat = 48.866667;
        this.lng = 2.333333;
        this.zoom = 13;
        this.initMap();
    }

    initMap()
    {
        this.createMapAndLayer();
        this.addMarkers();
        this.locateShopEvents();
    }

    createMapAndLayer()
    {
        const osm = new L.TileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            opacity: 0.7
        });

        this.map = L.map("modal-map-container", {
            center: [this.lat, this.lng],
            zoom: 13
        }).addLayer(osm);
        this.updateMap();
    }

    addMarkers()
    {

        let icon = L.icon({
            iconUrl: "/frontoffice/img/marker-icon.png",
            iconSize:    [25, 41],
            iconAnchor:  [12, 41]
        });

        this.querySelectorAll('map-marker').forEach(mapMarker => {
            let latLong = [mapMarker.dataset.latitude, mapMarker.dataset.longitude];
            var marker = L.marker(latLong, {
                icon: icon,
                title: mapMarker.dataset.name
            }).bindPopup(mapMarker.dataset.content).addTo(this.map);
            this.bounds.push(latLong);
        });
        this.updateMap(true);

    }

    locateShopEvents ()
    {

        this.querySelectorAll('.locate-shop').forEach((item) => {
            item.addEventListener('click',e => {
                e.preventDefault();
                this.lat = e.target.dataset.latitude;
                this.lng = e.target.dataset.longitude;
                this.updateMap();
            });
        });
    }

    updateMap( reload = false) {
        setTimeout(() => {
            this.map.invalidateSize();
            if (reload && this.bounds.length > 0) {
                this.map.fitBounds(this.bounds, {padding:[30,30]});
            } else {
                this.map.setView([this.lat, this.lng], this.zoom != undefined ? this.zoom : this.zoom);
            }
        },200);
    }
}
